import * as React from 'react'
import { PageTitle } from 'uiComponents/typography'
import './index.scss'
import { RELEASED_PAGE } from './htmlComponents'

function ReleaseNotes() {
    return (
        <div>
            <PageTitle>What&apos;s New</PageTitle>
            <div
                className="content"
                dangerouslySetInnerHTML={{
                    __html: RELEASED_PAGE,
                }}
             />
        </div>
    )
}

export default ReleaseNotes
